import React, { useEffect, useState } from "react";
import Modal from "../ModalConversion";
import { PaymentsService } from "../../services/PaymentsService";

const FIELDS = [
    'Nombre',
    'Dirección',
    'R.F.C.',
    'Banco',
    'Dirección del banco',
    'Cuenta CLABE',
    'No. de cuenta y sucursal',
    'Número de cuenta o IBAN',
    'Plaza de destino (país/ciudad)',
    'Número de SWIFT o ABA',
    'Banco intermediario',
    'Tipo Cve Bco intermediario',
    'Clave banco intermediario',
    'Información al banco intermediario',
];

const BillingDataModal = ({ isOpen, onClose, account }) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [lang, setLang] = useState('es');
    const [sending, setSending] = useState(false);
    const [message, setMessage] = useState(null);

    useEffect(() => {
        if (!isOpen || !account) return;
        setData(null);
        setMessage(null);
        setLang('es');
        setLoading(true);
        PaymentsService.getBillingData(account)
            .then((res) => setData(res))
            .catch((err) => setMessage({ type: 'error', text: err.message }))
            .finally(() => setLoading(false));
    }, [isOpen, account]);

    const handleSendReminder = async () => {
        setSending(true);
        setMessage(null);
        try {
            const res = await PaymentsService.sendBillingReminder(account, lang);
            if (res.status === 'success') {
                setMessage({ type: 'success', text: res.msg });
            } else {
                setMessage({ type: 'error', text: res.msg || 'No se pudo enviar el correo.' });
            }
        } catch (err) {
            setMessage({ type: 'error', text: err.message });
        } finally {
            setSending(false);
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="lg">
            <h3 className="text-white mb-2">Datos de facturación</h3>
            <p className="text-white-50 mb-3">Cuenta: <strong className="text-white">{account}</strong></p>

            {loading && <p className="text-center text-white-50 py-4">Cargando...</p>}

            {!loading && data && (
                <>
                    <div className="row g-3">
                        {FIELDS.map((label, i) => (
                            <div className="col-md-6" key={label}>
                                <label className="d-block small text-white-50 fw-bold mb-1">{label}</label>
                                <div className="text-white bg-white bg-opacity-10 rounded px-3 py-2">
                                    {data.data && data.data['field_' + i] ? data.data['field_' + i] : '-'}
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="d-flex flex-wrap gap-3 align-items-center justify-content-between mt-4 pt-3 border-top border-secondary">
                        <div className="small text-white-50">
                            Última modificación: <strong className="text-white">{data.inserted_date || '-'}</strong>
                            {' '}por <strong className="text-white">{data.user || '-'}</strong>
                        </div>
                        <div className="d-flex align-items-center gap-2">
                            <span className="text-white small">Enviar recordatorio en:</span>
                            <select
                                className="form-control form-control-sm bg-dark text-white border-secondary"
                                style={{ width: 'auto' }}
                                value={lang}
                                onChange={(e) => setLang(e.target.value)}
                            >
                                <option value="es">Español</option>
                                <option value="en">English</option>
                            </select>
                            <button
                                className="btn btn-warning btn-sm px-3"
                                onClick={handleSendReminder}
                                disabled={sending}
                            >
                                {sending ? 'Enviando...' : 'Enviar recordatorio de facturación'}
                            </button>
                        </div>
                    </div>

                    {message && (
                        <div className={`alert mt-3 mb-0 ${message.type === 'success' ? 'alert-success' : 'alert-danger'}`}>
                            {message.text}
                        </div>
                    )}
                </>
            )}
        </Modal>
    );
};

export default BillingDataModal;